import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "d-block mb-6 fs-13 text-uppercase" }
const _hoisted_4 = { class: "fw-black mb-12 lh-1" }
const _hoisted_5 = { class: "fw-bold text-success text-badge d-inline-block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chart fs-11 lh-1 position-relative top-1 ms-1" }, null, -1)
const _hoisted_7 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_8 = { class: "fs-6 position-relative" }
const _hoisted_9 = { class: "text-black fw-bold" }
const _hoisted_10 = { class: "fs-6 position-relative fw-medium" }
const _hoisted_11 = { class: "text-black fw-bold" }
const _hoisted_12 = { class: "fs-6 position-relative fw-medium" }
const _hoisted_13 = { class: "text-black fw-bold" }
const _hoisted_14 = {
  id: "earningChart",
  class: "chart"
}

import {  reactive } from "vue";

import * as serviceDashboard from "@/services/DashboardInvestidor";
import {f2dec} from "@/utils/funcoes";

export interface Iprops {
  resumoCidade: serviceDashboard.ResumoCidadeDto,
  totalTodasCidades: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumoCidade',
  props: {
    resumoCidade: {},
    totalTodasCidades: {}
  },
  setup(__props: any) {

var props = __props;

var controle = reactive({
  earnings: [ props.resumoCidade.totalRecebido, props.resumoCidade.totalAtrasado,props.resumoCidade.totalReceber],
  earningChart: {
        dataLabels: {
          enabled: false,
        },
        colors: ["#1FB1E6", "#dc3545", "#F3C44C"],
        legend: {
          show: false,
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#9C9AB6",
          },
          markers: {
            offsetX: -2,
            offsetY: 1,
          },
        },
        stroke: {
          width: 0,
        },
        tooltip: {
          enabled: false,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
})



return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(props).resumoCidade.nomeCidade), 1),
      _createElementVNode("h4", _hoisted_4, "R$ " + _toDisplayString(_unref(f2dec)(_unref(props).resumoCidade.totalContratos)), 1),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode(" REPRESENTAÇÃO " + _toDisplayString(_unref(f2dec)(_unref(props).resumoCidade.totalContratos / (_unref(props).totalTodasCidades / 100))) + "% ", 1),
        _hoisted_6
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createTextVNode(" RECEBIDO - "),
          _createElementVNode("span", _hoisted_9, "R$ " + _toDisplayString(_unref(f2dec)(_unref(props).resumoCidade.totalRecebido)), 1)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createTextVNode(" ATRASADO - "),
          _createElementVNode("span", _hoisted_11, "R$ " + _toDisplayString(_unref(f2dec)(_unref(props).resumoCidade.totalAtrasado)), 1)
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createTextVNode(" RECEBER - "),
          _createElementVNode("span", _hoisted_13, "R$ " + _toDisplayString(_unref(f2dec)(_unref(props).resumoCidade.totalReceber)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_apexchart, {
          type: "donut",
          height: "150",
          options: _unref(controle).earningChart,
          series: _unref(controle).earnings
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}
}

})